import { Component, Input, OnInit } from '@angular/core';
import { PrTooltipIconComponent } from '../pr-tooltip-icon/pr-tooltip-icon.component';

@Component({
    selector: 'pr-label',
    templateUrl: './pr-label.component.html',
    styleUrls: ['./pr-label.component.scss'],
    standalone: false
})
export class PrLabelComponent extends PrTooltipIconComponent implements OnInit {
  @Input() class;
  @Input() labelClass: string = '';
  @Input() labelDefaultClass: string;

  constructor() {
    super();
  }

  ngOnInit() {}
}
